import React, { Component } from 'react'
import styled from 'styled-components'

const StyledImageWrapper = styled.img`
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  height: ${props => (props.height ? props.height : ' 42px')};
  width: ${props => (props.width ? props.width : 'auto')};
  object-fit: ${props => (props.objectFit ? props.objectFit : 'contain')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : 0)};
  margin: ${props => (props.margin ? props.margin : '0 auto')};
  background: ${props => props.background || 'transparent'};
  &:hover {
    opacity: 0.7;
    transition: 0.2s;
  }
`

class StyledImage extends Component {
  state = {}
  render() {
    const { ...props } = this.props
    return <StyledImageWrapper {...props} />
  }
}

export default StyledImage



// WEBPACK FOOTER //
// ./src/components/StyledImage.js